import type {DestinationConnection} from '#types/destinations.js';
import {DestinationType} from '#types/destinations.js';
import type {Nullable} from '#lit/types/general.js';

export function isCSV(destination: Nullable<DestinationConnection>) {
  return destination?.platform_type === DestinationType.CSV;
}
